<template>
  <div>
    <jd-tip>
      <div>仅展示发放记录内参与用户发放后7天的订单数据</div>
    </jd-tip>
    <jd-form
      ref="biOrderInputRef"
      class="mb16 mt16"
      :form-data.sync="formData"
      :form-info="inputOrderDetail"
      @search="searchOrderDetail"
    />
    <div class="new-table-box">
      <jd-table
        :loading="loading"
        :tableData="orderDetailData"
        :pageInfo="{
          pageNum: orderDetailPage.current,
          pageSize: orderDetailPage.size,
          total: orderDetailPage.total,
        }"
        @handlePage="
          (val) => {
            orderDetailPage.current = val.pageNum;
            orderDetailPage.size = val.pageSize;
            getList();
          }
        "
      >
        <el-table-column prop="orderId" label="订单号"> </el-table-column>
        <el-table-column prop="chaosPin" label="用户pin（加密）">
        </el-table-column>
        <el-table-column prop="memberNick" label="用户昵称">
        </el-table-column>
        <el-table-column prop="sourcePopupName" label="来源弹窗"></el-table-column>
        <el-table-column prop="orderStartTime" label="下单时间">
        </el-table-column>
        <el-table-column prop="paymentConfirmTime" label="付款时间">
        </el-table-column>
        <el-table-column prop="orderPayment" label="订单金额"></el-table-column>
        <el-table-column prop="orderStateRemark" label="订单状态">
          <template #default="{row}">
           <jd-status :status="getStatus(row.orderStateRemark,row.orderState)">{{ row.orderStateRemark }}</jd-status> 
          </template>
        </el-table-column>
      </jd-table>
    </div>
  </div>
</template>

<script>
import { getBiOrderDetailPage } from "@/api/jhk/paradiseAndTaskCommonController.js";
export default {
  props: {
    rowData: {
      // 活动数据
      type: Object,
      default: () => {},
    },
    inputInfo: {
      type: Array,
      default: () => [],
    },
    sourcePopupList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: {
        pin: "",
        orderId: "",
        orderState: "",
        startTime: "",
        endTime: "",
        biShopGiftPopupId: "",
      },
      loading: false, // 加载
      orderDetailData: [], // 订单明细
      orderDetailPage: {
        // 订单明细分页
        current: 1, // 当前页
        size: 10, // 每页条数
        total: 0, // 总条数
      },
    };
  },
  computed: {
    inputOrderDetail:{
      get() {
        return this.inputInfo;
      },
      set(val) {
        this.$emit("update:inputInfo", val);
      },
    }
  },
  watch: {
    sourcePopupList: {
      handler(newVal, oldVal) {
        if(newVal.length > 0) {
          // 避免重复添加
          if(this.inputOrderDetail.find(item => item.prop == 'biShopGiftPopupId')) {
            return
          } 
          this.inputOrderDetail.push({
            label: "来源弹窗：",
            prop: "biShopGiftPopupId",
            type: "Select",
            value: "",
            options: newVal,
          })
          this.$nextTick(() => {
            this.$refs.biOrderInputRef.reData();
          });
        }
      },
      deep: true,
      immediate: true,
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getStatus(tips,orderState){
      if(tips=='已完成' || orderState=='FINISHED_L'){
        return 0
      }else if(tips=='等待出库' || orderState=='WAIT_SELLER_STOCK_OUT' || tips == '等待确认收货' || orderState=='WAIT_GOODS_RECEIVE_CONFIRM'){
        return 1
      }else if(tips=='未付款' || orderState=='WAIT_PAYMENT'){
        return 2
      }else if(tips=='退货' || orderState=='LOCKED' || tips=='暂停' || orderState=='PAUSE'){
        return 3
      }else if(tips=='已取消' || orderState=='TRADE_CANCELED'){
        return 4
      }
    },
    getList() {
      this.loading = true;
      const query = {
        size: this.orderDetailPage.size,
        current: this.orderDetailPage.current,
        activityId: this.rowData.id,
        ...this.formData
      };
      getBiOrderDetailPage(query)
        .then((res) => {
          let { records = [], total = 0 } = res.data || {};
          this.loading = false;
          this.orderDetailData = records;
          this.orderDetailPage.total = Number(total);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 订单明细搜索
    searchOrderDetail(val) {
      this.formData.orderState = val.orderState ? val.orderState.join(',') : "";
      this.orderDetailPage.current = 1;
      this.orderDetailPage.size = 10;
      this.getList();
    },
    // 订单明细分页-数量
    handleSizeOrderDetail(size) {
      this.orderDetailPage.size = size;
      this.getList();
    },
    // 订单明细分页-页数
    handleCurrentOrderDetail(current) {
      this.orderDetailPage.current = current;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
